import styled from 'styled-components/macro';

import { Link } from '../../../shared-styles';

export const MainContainer = styled.div`
  padding: 0px ${(props) => props.theme.spacing(30)};
`;

export const PageTitle = styled.h1`
  font-weight: ${(props) => props.theme.typography.weight.bold};
  border-bottom: 1px solid ${(props) => props.theme.palette.black[50]};;
  padding-bottom: ${(props) => props.theme.spacing(20)};
`;

export const NavIcon = styled.img`
  transform: scaleX(-1);
  margin-right: ${(props) => props.theme.spacing(10)};
`;

export const HeaderLink = styled.div`
  ${Link}
  margin-left: auto;
  text-decoration: none;
  margin-bottom: ${(props) => props.theme.spacing(15)};
  margin-top: ${(props) => props.theme.spacing(15)};
`;
